module.exports = __webpack_public_path__ + "static/media/david.fb44ae01.jpeg";